/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 0
// module chunks = 0